import React from 'react';
import NavbarLg from './NavbarLg';
import NavbarSm from './NavbarSm';
import './Navigation.css';

const Navigation = () => {
    return (
        <div className='navigation-layer'>
            <div className='d-none d-lg-block navbar-sticky-layer container'><NavbarLg /></div>
            <div className='d-lg-none navbar-sticky-layer container'><NavbarSm /></div>
        </div>
    );
}

export default Navigation;